const STORAGE_KEY = 'falcon-planner:predecessor-picker-grid-shell';

export type PredecessorGridShell = 'drawer' | 'floating';

const DEFAULT_SHELL: PredecessorGridShell = 'drawer';

function normalize(value: unknown): PredecessorGridShell {
  return value === 'floating' ? 'floating' : 'drawer';
}

/** Load grid predecessor-picker shell preference for this tab session. */
export function loadPredecessorGridShell(): PredecessorGridShell {
  if (typeof window === 'undefined') return DEFAULT_SHELL;
  try {
    return normalize(window.sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return DEFAULT_SHELL;
  }
}

/** Persist grid predecessor-picker shell preference for this tab session. */
export function savePredecessorGridShell(shell: PredecessorGridShell): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, shell);
  } catch {
    // ignore quota / private mode
  }
}
